<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        title="PrinterQueue"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreMaterial/PrinterQueue/PrinterQueueDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import PrinterQueueDetail from "@/components/CoreMaterial/PrinterQueue/PrinterQueueDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "PrinterQueueTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'PrinterQueueTable'},
    dtoDetailQuery: {default: 'PrinterQueueDetailQueryDTO'},
    detailStoreName: {default: 'PrinterQueueDetail'},
    dtoValidateCommand: {type: [String], default: 'PrinterQueueValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'PrinterQueueListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'PrinterQueueActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    PrinterQueueDetail,
    BaseFieldCheck,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Queue name', value: 'queue_name', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Printer name', value: 'printer_name', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Executed', value: 'executed', sortable: false, filterable: true, divider: true, width: 80, type: 'bool'},
      {text: 'Label', value: 'label', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Data', value: 'data', sortable: false, filterable: true, divider: true, width: 300},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['created_on']
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>